// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.SelectTenantPopup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------
import React, { Component } from 'react';
import * as _ from 'lodash/fp';
import PropTypes from 'prop-types';

import connect from 'share/enhancers/Izenda.Connect';
import Input from 'share/components/controls/Izenda.Input';
import EventUtils from 'share/utils/Izenda.EventUtils';
import { EMPTY_GUID } from 'logic/data/Izenda.AppGlobalConstants';

@connect()
export default class SelectTenant extends Component {

  static propTypes = {
    tenantGroups: PropTypes.any.isRequired
  };

  /**
   * Render single tenant grouping tenants
   * @param {Object} grouping
   */
  renderTenantGroupingItems(grouping) {
    const onGroupItemChange = groupingItem => {
      groupingItem.checked = !groupingItem.checked;
    };

    return grouping.tenantGroupItems.map((groupingItem, groupingItemIndex) => {
      return (
        <div className="u_paddingAll u_marginLeft" key={groupingItemIndex}>
          <Input type="checkbox"
                 checked={groupingItem.checked}
                 disabled={groupingItem.disabled}
                 onChange={EventUtils.notifyChange(_.partial(onGroupItemChange, [groupingItem]), EventUtils.CHECKBOX)}/>
          <span>{groupingItem.tenantName}</span>
        </div>
      );
    });
  }

  render() {
    const { tenantGroups } = this.props;
    const onGroupChange = grouping => {
      grouping.checked = !grouping.checked;
      grouping.tenantGroupItems.forEach(x => {
        x.checked = grouping.checked;
        x.disabled = grouping.checked;
      });
    };

    return (
      <div>
        {tenantGroups.map((grouping, groupingIndex) => {
          return (
            <div key={`tenantGrouping${groupingIndex}`}>
              <div className="u_paddingAll">
                <Input type="checkbox"
                       checked={grouping.checked && grouping.tenantGroupId !== EMPTY_GUID}
                       disabled={grouping.disabled || grouping.tenantGroupId === EMPTY_GUID}
                       onChange={EventUtils.notifyChange(_.partial(onGroupChange, [grouping]), EventUtils.CHECKBOX)}/>
                <span>{grouping.tenantGroupName}</span>
              </div>
              {this.renderTenantGroupingItems(grouping)}
            </div>
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/SelectTenant/Izenda.SelectTenant.js